import { VStack, Text, Box, HStack } from '@chakra-ui/react';
import CopyButton from './CopyButton';

interface ContactSupportProps {
    variant?: 'card' | 'minimal';
}

const ContactSupport = ({ variant = 'card' }: ContactSupportProps) => {
    const email = 'support@yaxle.com';

    if (variant === 'minimal') {
        return (
            <HStack justifyContent="center" spacing={2} w="100%">
                <Text color="gray.500" fontSize="sm">
                    Need help?
                </Text>
                <Text color="gray.400" fontSize="sm">|</Text>
                <CopyButton
                    text={email}
                    label="Copy email"
                    iconSize={4}
                    color="gray.500"
                    _hover={{ color: 'gray.700', bg: 'gray.200' }}
                    tooltipAnchor={
                        <Text color="gray.700" fontSize="sm" fontWeight="medium">
                            {email}
                        </Text>
                    }
                />
            </HStack>
        );
    }

    return (
        <Box
            bg="white"
            border="1px solid"
            borderColor="gray.200"
            borderRadius="lg"
            boxShadow="none"
            p={4}
            w="100%"
        >
            <VStack justifyContent="center" gap={2}>
                <Text color="gray.500" fontSize="sm">
                    Need help?
                </Text>
                <Box bg="gray.100" borderRadius="md" px={3} py={2}>
                    <CopyButton
                        text={email}
                        label="Copy email"
                        iconSize={4}
                        color="gray.500"
                        _hover={{ color: 'gray.700', bg: 'gray.200' }}
                        tooltipAnchor={
                            <Text color="gray.700" fontSize="sm" fontWeight="medium">
                                {email}
                            </Text>
                        }
                    />
                </Box>
            </VStack>
        </Box>
    );
};

export default ContactSupport;
